export default __webpack_public_path__ + "d789e718055204db06d581cfcda725b2.webp";